//NOSONAR
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import type { KeycloakInstance } from 'keycloak-js'
import Keycloak from 'keycloak-js'
import { type Config } from '../public/type.customerportal'
import { setSitecoreCookies } from './utils/CookieUtils'
import { setCpUserIdCookie } from './utils/CpUserIdUtils'
import { setRedPartnerStatusCookie } from './utilsTenant/RedCooperationUtils'
import { isDa } from './utils/CommonUtils'
import { router } from './router/router'
import { mockKeycloak } from './keycloak.mock.sonarExclude'

function fixUrl(url: string) {
  if (url.includes('/da/')) {
    url = url.replace('/da/', '')
  }
  if (url.includes('/mz')) {
    url = url.replace('/mz', '')
  }
  if (location.origin.includes('webuidev.azureedge.net')) {
    url = url + '.html'
  }
  if (location.origin.includes('webuisit.azureedge.net')) {
    url = url + '.html'
  }
  return url
}

const setCookies = async () => {
  if (!globalThis.ENV_CONFIG?.BASE_URL.includes('helpdesk-portal')) {
    setSitecoreCookies(window.keycloak.refreshToken)
    await setCpUserIdCookie()
    if (isDa()) await setRedPartnerStatusCookie()
  }
}

const dispatchSuccess = () => {
  window.dispatchEvent(
    new CustomEvent('cp_keycloak_auth_success', {
      bubbles: true,
      detail: {}
    })
  )
}

export const initKeycloak = async (
  redirectUri?: string,
  loginHint?: string
): Promise<boolean> => {
  // Resolve redirect URI: prefer value stored in localStorage, otherwise use provided redirectUri
  const resolvedRedirectUri: string | undefined =
    localStorage.getItem('redirectUri') ?? redirectUri

  if (window.origin.includes('localhost')) {
    mockKeycloak()
    await setCookies()
    dispatchSuccess()
    if (loginHint) await router.push('/ueberblick')
    return true
  }

  const keycloak_config = {
    realm: globalThis.ENV_CONFIG?.KEYCLOAK.REALM,
    clientId: globalThis.ENV_CONFIG?.KEYCLOAK.CLIENT,
    url: globalThis.ENV_CONFIG?.KEYCLOAK.BASE_URL + '/auth'
  }

  const keycloak = new Keycloak(keycloak_config)
  try {
    if (loginHint) {
      localStorage.setItem('loginHint', loginHint)
    }

    const success = await keycloak.init({
      checkLoginIframe: false,
      onLoad: localStorage.getItem('loginHint') ? 'check-sso' : 'login-required',
      silentCheckSsoRedirectUri: fixUrl(
        location.origin + globalThis.ENV_CONFIG?.BASE_URL + '/silent-check-sso'
      ),
      ...(resolvedRedirectUri !== undefined ? { redirectUri: resolvedRedirectUri } : {})
    })

    window.keycloak = keycloak

    const storedLoginHint = localStorage.getItem('loginHint')

    if (storedLoginHint) {
      localStorage.removeItem('loginHint')

      await keycloak.login({
        loginHint: storedLoginHint,
        redirectUri: resolvedRedirectUri
      })

      return true
    }

    await setCookies()
    dispatchSuccess()
    return success
  } catch (error) {
    window.dispatchEvent(
      new CustomEvent('cp_keycloak_auth_fail', {
        bubbles: true,
        detail: {}
      })
    )
    console.log('catch', error)
    const p = document.createElement('p')
    const text = document.createTextNode(
      'Fehler bei der Initialisierung des Kundenportal.'
    )
    p.appendChild(text)
    const div = document.getElementById('cp')
    if (div) {
      div.innerHTML = ''
      div.appendChild(p)
    }
    return false
  }
}

declare global {
  interface Window {
    ENV_CONFIG: Config
    keycloak: KeycloakInstance
  }
}
